import * as React from "react";
import { cn } from "@repo/utils/utils";
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
    return (<input type={type} className={cn("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base text-gray-800 file:border-0 file:bg-transparent file:text-sm file:text-foreground placeholder:text-muted-foreground/60 field-focus focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", className)} ref={ref} {...props}/>);
});
Input.displayName = "Input";
export { Input };
